import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X, Shield } from 'lucide-react';
import { Button } from './ui/button';

const KEY = 'amaia_cookie_consent_v1';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-4 bottom-4 z-50 sm:inset-x-auto sm:bottom-6 sm:left-6 sm:max-w-md">
      <div className="rounded-2xl border border-neutral-200 bg-white p-5 shadow-xl">
        <div className="mb-3 flex items-start gap-3">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-neutral-900 text-white">
            <Shield className="h-4 w-4" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-neutral-900">Your privacy matters</h3>
            <p className="mt-1 text-xs leading-relaxed text-neutral-600">
              We use essential cookies to operate this site and, with your consent, optional analytics cookies to improve it. Data is processed in accordance with GDPR. See our{' '}
              <Link to="/legal" className="underline underline-offset-2 hover:text-neutral-900">Privacy Policy</Link>.
            </p>
          </div>
          <button onClick={() => accept('dismissed')} className="rounded-md p-1 text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700" aria-label="Dismiss">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="flex gap-2">
          <Button size="sm" onClick={() => accept('rejected')} variant="outline" className="flex-1 border-neutral-300">
            Reject non-essential
          </Button>
          <Button size="sm" onClick={() => accept('accepted')} className="flex-1 bg-neutral-900 text-white hover:bg-neutral-800">
            Accept all
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
